module.exports = __webpack_public_path__ + "img/twitter_example_3.bb312f19.jpg";